<template>
  <div class="login">
    <div class="wrap">
      <div class="logo">
        <img src="../assets/logo.png">
        <h2>{{title}}</h2>
      </div>
      <div class="fm">
        <div class="item">
          <el-input placeholder="请输入用户名" icon="x-user" v-model="userinfo.name">
          </el-input>
        </div>
        <div class="item">
          <el-input placeholder="请输入密码" icon="x-lock" v-model="userinfo.pwd" type="password">
          </el-input>
        </div>
        <div class="item">
          <el-button type="primary" style="width:100%;" :loading="loading" @click="login">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from './ajax'

export default {
  name: 'xlogin',
  props: ['url', 'title'],
  data() {
    return {
      loading: false,
      userinfo: {
        name: '',
        pwd: ''
      }
    }
  },
  methods: {
    login() {
      if(!this.verify()){
        return false;
      }
      this.loading = true;
      let _self = this;
      ajax(this, 'post', this.url, this.userinfo, (res) => {
        _self.$message({
          showClose: true,
          message: '登陆成功',
          type: 'success'
        });
        _self.$emit('loginSuccess');
      }, () => {
        _self.loading = false;
      })
    },
    verify(){
      if(this.userinfo.name.trim() == '' || this.userinfo.pwd == ''){
        this.$message({
          showClose: true,
          type: 'warning',
          message: '请输入用户名与密码'
        });
        return false;
      }else{
        return true;
      }
    }
  } 
}
</script>


// WEBPACK FOOTER //
// login.vue?016071e8